module.exports = __webpack_public_path__ + "img/iconGeral.fd32ec0b.svg";